import React from "react"
import {
  BOUNDARY_ISSUE_LABELS,
  CONTROL_SURVEY_TIME_SPENT_WARNING_THRESHOLD
} from "utils/constants"

const isBlankBoundaryIssueType = boundaryIssueType => (
  !boundaryIssueType || String(boundaryIssueType).trim() === ""
)

const isRealBoundaryIssue = boundaryIssueType => (
  !isBlankBoundaryIssueType(boundaryIssueType) &&
  boundaryIssueType !== "none_of_the_above"
)

const isNoIssueType = boundaryIssueType => (
  isBlankBoundaryIssueType(boundaryIssueType) ||
  boundaryIssueType === "none_of_the_above"
)

export const shouldShowBoundaryIssueWarning = (boundaryIssueType, controlSurveyTimeSpentHours) => {
  const hours = Number(controlSurveyTimeSpentHours) || 0
  return isRealBoundaryIssue(boundaryIssueType) || hours > CONTROL_SURVEY_TIME_SPENT_WARNING_THRESHOLD
}

const BoundaryIssueWarningBanner = ({
  boundaryIssueType,
  boundaryIssueResolutionComment,
  controlSurveyTimeSpentHours,
  className = ""
}) => {
  const hours = Number(controlSurveyTimeSpentHours) || 0
  const hasBoundaryIssue = isRealBoundaryIssue(boundaryIssueType)
  const timeSpentOverThreshold = hours > CONTROL_SURVEY_TIME_SPENT_WARNING_THRESHOLD
  const showNoIssueLabel = isNoIssueType(boundaryIssueType) && timeSpentOverThreshold
  const showIssueLabel = hasBoundaryIssue || showNoIssueLabel
  const boundaryIssueLabel = showNoIssueLabel
    ? "No Issue"
    : (BOUNDARY_ISSUE_LABELS[boundaryIssueType] || boundaryIssueType)
  const showTimeSpent = timeSpentOverThreshold

  if (!shouldShowBoundaryIssueWarning(boundaryIssueType, hours)) {
    return null
  }

  return (
    <div
      className={`rounded py-2 px-3 small text-dark ${className}`.trim()}
      style={{
        backgroundColor: "#fff3cd",
        maxWidth: "min(100%, 26rem)",
      }}>
      {showIssueLabel && (
        <div>
          <strong>{boundaryIssueLabel}:</strong>
          {hasBoundaryIssue && boundaryIssueResolutionComment ? (
            <>
              {" "}
              {boundaryIssueResolutionComment}
            </>
          ) : null}
        </div>
      )}
      {showTimeSpent && (
        <div
          className={showIssueLabel ? "mt-1" : undefined}
          style={{ backgroundColor: "#dc3545", color: "#fff", display: "inline-block", padding: "0 0.25rem" }}>
          Time Spent: {hours}
        </div>
      )}
    </div>
  )
}

export default BoundaryIssueWarningBanner
